/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Analysis_BeforeInputs */

const en_gc_guides_analysis_before = /** @type {(inputs: Gc_Guides_Analysis_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use one header row and one record per row. Keep a revenue column numeric, use consistent category names and remove blank rows inside the source range. The desktop GridCraft app offers more room to explore the ribbon and the field list; the sales sample in the web editor is a convenient starting point for looking around. This tutorial describes the desktop workflow, and controls may differ between alpha versions.`)
};

const zh_gc_guides_analysis_before = /** @type {(inputs: Gc_Guides_Analysis_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用一行表头，每行放一条记录。收入列保持数字格式，分类名称保持一致，并清除来源区域中的空行。桌面 GridCraft 应用更方便探索功能区与字段列表，网页销售示例适合先熟悉界面。本教程描述桌面流程，不同 Alpha 版本的控件可能不同。`)
};

/**
* | output |
* | --- |
* | "Use one header row and one record per row. Keep a revenue column numeric, use consistent category names and remove blank rows inside the source range. The de..." |
*
* @param {Gc_Guides_Analysis_BeforeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_analysis_before = /** @type {((inputs?: Gc_Guides_Analysis_BeforeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Analysis_BeforeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_analysis_before(inputs)
	return zh_gc_guides_analysis_before(inputs)
});
export { gc_guides_analysis_before as "gc.guides.analysis.before" }